import { buildServiceParamMap, enrichDataWithIncluded } from '@/common/utils'
import { RRS_URL } from '@/common/constants'
import jwtInterceptor from '@/common/jwt-interceptor-wrapper'

const helpers = {
  singleRallyParams: (rallyId) => {
    const params = buildServiceParamMap({
      id: rallyId,
      include: 'avatar,child_count,is_hub,member_count,my_membership,parent',
    })

    return {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json'
      },
      url: RRS_URL() + '/rallies',
      params: Object.fromEntries(params)
    }
  },
}

const state = {
  currentRally: null,
}

const getters = {
  currentRally: (state) => state.currentRally,
}

const mutations = {
  setCurrentRally: (state, payload) => {
    state.currentRally = payload
  },
}

const actions = {
  clearCurrentRally({ commit, state }) {
    commit('setCurrentRally', null)
  },

  async fetchCurrentRallyData({ commit }, inparams ) {
    const { rallyId } = inparams
    const requestOptions = helpers.singleRallyParams(rallyId)
    const response = await jwtInterceptor(requestOptions)
    const enrichedData = enrichDataWithIncluded(response)
    const currentRally = enrichedData[0]?.attributes
    commit('setCurrentRally', currentRally)
  },
}

export default {
  namespaced: true,
  actions,
  getters,
  mutations,
  state,
}
